import { FileText, Download } from 'lucide-react';
import { fmtSize } from '../../utils/chatUpload';

export const FileChip = ({ file, href, dark = false }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" download={file.name}
    className={`flex items-center gap-2.5 min-w-[180px] max-w-full rounded-xl px-3 py-2 transition-colors ${dark ? 'bg-black/25 hover:bg-black/35' : 'bg-gray-50 hover:bg-gray-100 border border-gray-200 text-gray-800'}`}
    data-testid={`chat-file-${file.id}`}>
    <FileText size={20} className="shrink-0 opacity-80" />
    <span className="min-w-0 flex-1">
      <span className="block text-sm font-medium truncate">{file.name}</span>
      <span className="block text-[11px] opacity-70">{fmtSize(file.size)}</span>
    </span>
    <Download size={15} className="shrink-0 opacity-70" />
  </a>
);
